export default "__VITE_ASSET__cac15fc7__"